export default __webpack_public_path__ + "static/media/assembly_4.2f78f4e8.png";